import React from "react";
import { useSelector } from "react-redux";

export const PopupContainer = (props) => {
    const lang = useSelector(state => state.app.currentLang)
    let popupBody = false;
    let loading;

    if(Array.isArray(props.popup) && props.popup.length > 0 ) popupBody = true;
    else if(typeof props.popup === 'object' && props.popup !== null) popupBody = true;

    if (typeof props.popupLoading === 'undefined') loading = false;
    else loading = props.popupLoading;
    return (
        <div className="popupContainer">
            <div className="popupContainer__back" onClick={() => props.close()}></div>
            <div className="popupContainer__wrap">
                <div className="popupContainer__box">
                    <div className="popupContainer__head">
                        {props.popupName}
                        <div className="popupContainer__close" onClick={() => props.close()}>
                        </div>
                    </div>
                    {
                        !popupBody && loading && (<div className="popupContainer__loading"></div>)
                    }
                    {
                        !popupBody && !loading && (
                            <div className="popupContainer__heading"><span>{lang.message7}</span></div>)
                    }
                    {
                        popupBody && (
                            <React.Fragment>
                                <div className="popupContainer__heading"><span>{props.heading}</span></div>
                                <div className="popupContainer__body">
                                    {props.children}
                                </div>
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        </div>
    )
}